import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { TextButton, Typography } from 'seagull';
import { useIoContext } from '~/contexts';
export const ActivityLogNavLink = (param)=>{
    let { to, bi, children, testId, onClick } = param;
    const { native } = useIoContext();
    if (native.isNative) {
        return /*#__PURE__*/ _jsx(Typography, {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(TextButton, {
        bi: bi,
        as: Link,
        to: to,
        onClick: onClick,
        testId: testId,
        underline: "none",
        children: children
    });
};
